import $ = require('jquery');
import DropZone = require('diy/common/js/dd/DropZone');
import DragSource = require('diy/common/js/dd/DragSource');
import ModuleDragSource = require('./ModuleDragSource');
import Matrix from '../Matrix';
/**
 * Drop zone for matrix areas
 *
 * @depends Matrix.js
 * @depends jquery.ui.sortable.js
 */
    let placeholderCache = $('<div></div>')
        .addClass('diye-placeholder-wrapper')
        .html(
            '<div class="diye-placeholder">' +
            '<div class="diye-placeholder-border"></div>' +
            '<div class="diye-placeholder-innerborder"></div>' +
            '<div class="diye-placeholder-text"></div>' +
            '</div>'
        );

    class MatrixDropZone extends DropZone {
        private placeholder: JQuery;

        constructor(targetEl: JQuery) {
            super(targetEl, targetEl);

            //We create the sortable here because the drop zone is created too late
            //and connecToSortable won't work on the draggables
            this.element.sortable({
                disableTouch: true,
                items: '>div.modulelt',
                placeholder: <any>{
                    element: function() {
                        return placeholderCache[0];
                    },
                    update: function() { /*empty */}
                },
                connectWith: '.sortable-matrix:not(#' + this.element.attr('id') + ')',
                cancel: '*', //we're using the sortable as a drop zone not as a drag source
                cursor: null, //force no cursor or it will overwrite the cursor on body
                //keep this setting (intersect generates bogus out event while overlapping both matrixes :|)
                tolerance: 'pointer',
                dropBehaviour: true
            });
        }

        activate() {
            super.activate();

            this.element
                .addClass('dragging-in-progress')
                .sortable('refreshPositions');

            this.element
                .bind('sortstart.dropzone', $.proxy(this.onDragOver, this))
                .bind('sortout.dropzone', $.proxy(this.onDragOut, this))
                .bind('sortbeforestop.dropzone', $.proxy(this.onDrop, this));
        }

        getDestinationParams() {
            let params = {
                matrixId: this.getMatrixId(),
                pageId: 0,
                afterChildId: 0
            };

            let previousModule = this.placeholder.prevAll('.modulelt[data-matrixChildId]');
            if (previousModule.length > 0) {
                params.afterChildId = parseInt(previousModule.attr('data-matrixChildId'), 10);
            }

            return params;
        }

        getMatrixId() {
            return parseInt(this.getTargetEl().attr('data-matrixId'), 10);
        }

        showCanDrop(canDrop: boolean) {
            let matrixId = this.getTargetEl().attr('data-matrixId');

            this.element[canDrop ? 'removeClass' : 'addClass']('restricted-area');
            let matrix = Matrix.getInstance(matrixId);
            if (canDrop) {
                matrix.hideWarningVeil();
            } else {
                matrix.showWarningVeil();
            }
        }

        showInvitation(canDrop: boolean) {
            this.showCanDrop(canDrop);
            this.placeholder[canDrop ? 'show' : 'hide']();
        }

        hideInvitation() {
            this.showCanDrop(true);
            this.placeholder.hide();
        }

        updateView(dragSource: DragSource) {
            super.updateView(dragSource);

            if (dragSource) {
                let placeholderText: string;
                if (dragSource instanceof ModuleDragSource) {
                    placeholderText = dragSource.getLabel();
                } else {
                    placeholderText = '';
                }

                this.placeholder.find('.diye-placeholder-text').html(placeholderText);
            }
        }

        onDragOver(e: Event, ui: {placeholder: JQuery}) {
            this.placeholder = ui.placeholder;
            super.onDragOver(e, ui);
        }

        onDragOut(e: Event, ui: {placeholder: JQuery}) {
            this.placeholder = ui.placeholder;
            super.onDragOut(e, ui);
        }

        onDrop(e: Event, ui: {item: JQuery}) {
            //remove the dummy element that's automatically appended by the sortable
            ui.item.remove();
            super.onDrop(e, ui);
        }

        getPageId() {
            return parseInt($("body").attr("data-pageid"), 10);
        }

        refresh() {
            this.element.sortable('refresh');
        }

        deactivate() {
            this.element.removeClass('dragging-in-progress');

            this.element.unbind('.dropzone');
        }

        destroy() {
            this.element.sortable('destroy');
            this.placeholder = null;
            super.destroy();
        }
    }

export = MatrixDropZone;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/dd/MatrixDropZone.ts
 **/